'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.factory('imagePreload', function ($q) {
    return function (urls) {
      if (!(urls instanceof Array)) return $q.reject('Input is not an array');

      var promises = [];

      for (var i = 0; i < urls.length; i++) {
        var deferred = $q.defer();
        var img = new Image();

        img.onload = function (deferred) {
          return function () {
            deferred.resolve();
          };
        }(deferred);

        img.onerror = function (deferred, url) {
          return function () {
            deferred.reject(url);
          };
        }(deferred, urls[i]);

        promises.push(deferred.promise);
        img.src = urls[i];
      }

      return $q.all(promises);
    };
  });
  return app;
};

require('angular');

/**
 * 图片预加载
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/lib/angular1.x-common/services/imagePreload.js
// module id = 149
// module chunks = 0